<template>
    <div class="container">

        <div class="top-wrapper">
            <div class="nav-item" id="right-nav-item" @click="goNews()">
                <img src="../../../assets/image/member/m-tz.png" class="nav-icon">
                <span v-if="0"></span>
            </div>
            <div class="top-info-wrapper">
                <div class="avatar-wrapper">
                    <img class="avatar" src="../../../assets/image/member/favicon.png" />
                </div>
                <p class="nickname">{{ user.member_name }}</p>
            </div>
            <div class="info-wrapper">
                <div class="info-item" @click="goAccount">
                    <div class="item">{{ $t('USDT') }}</div>
                    <div class="item price">${{ getAvailablePredeposit }}</div>
                </div>
                <div class="info-item" @click="goCommission(0)">
                    <div class="item">{{ $t('Direct') }}</div>
                    <div class="item price">$ {{ user.share_price }}</div>
                </div>
                <div class="info-item" @click="goCommission(1)">
                    <div class="item">{{ $t('Indirect') }}</div>
                    <div class="item price">$ {{ user.parent_share_price }}</div>
                </div>
            </div>
        </div>
        <mt-swipe class="banner" style="height: 4.1rem;" :speed="600" :show-indicators="false">
            <mt-swipe-item>
                <img src="../../../assets/image/home/gobuy.png" @click="gotobuy" alt="gobuy">
            </mt-swipe-item>
            <mt-swipe-item>
                <img src="../../../assets/image/member/Recycle.png" @click="goGiftSave" alt="Recycle">
            </mt-swipe-item>
        </mt-swipe>
        <div class="" style="margin: .6rem 3.6rem;">
            <div class="common-btn ds-button-large" @click="logout">{{ $t('Log Out') }}</div>
        </div>
    </div>
</template>
  
<script>
import IndexOrderItem from './IndexOrderItem'
import IndexManageItem from './IndexManageItem'
import flexLine from '../../flexLine'
import GuessLike from '../../GuessLike'
import { mapState, mapActions, mapMutations } from 'vuex'
import { getMemberIndex, boxList, giftList, get_config } from '../../../api/member'
import { logout, signout, getMemberInfo } from '../../../api/member'
import { checkInviter } from '../../../api/memberInviter'
import { Toast, MessageBox } from 'mint-ui'
export default {
    name: 'MemberIndexIndex',
    data() {
        return {
            user: {},
            time: '',
            orderCount: {},
            isShow: true,
            box_dot: {},  //盲盒徽标
            gift_dot: {},  //礼品卡徽标
            email_to: ''
        }
    },
    components: {
        flexLine,
        IndexOrderItem,
        IndexManageItem,
        GuessLike
    },
    created: function () {
        this.utils.preloadImages(['https://ysmhh.s3.amazonaws.com/1.gif', 'https://ysmhh.s3.amazonaws.com/2.gif'])



        this.time = new Date().getTime()
        this.fetchConfig({}).then(
            response => {
            },
            error => {
                Toast(error.message)
            }
        )
        if (this.isOnline) {
            boxList().then(
                response => {
                    if (response && response.result) {
                        this.box_dot = response.result
                    }
                },
                error => { }
            )
            giftList().then(
                response => {
                    if (response && response.result) {
                        this.gift_dot = response.result
                    }
                },
                error => { }
            )

            getMemberIndex().then(
                response => {
                    if (response && response.result.member_info) {
                        this.user = response.result.member_info
                    }
                },
                error => { }
            )
        }
    },
    computed: {
        ...mapState({
            isOnline: state => state.member.isOnline,
            config: state => state.config.config
        }),

        nickname() {
            let title = '登录/注册'
            if (this.isOnline) {
                if (
                    this.user &&
                    typeof this.user !== 'undefined' &&
                    JSON.stringify(this.user) !== '{}'
                ) {
                    title = this.user.member_nickname
                }
            }
            return title
        },
        getScore() {
            let score = '0'
            if (this.isOnline && this.user.member_points) {
                score = this.user.member_points
            }
            return score
        },
        // 预存款可用金额 通过store 进行获取
        getAvailablePredeposit() {
            let availablePredeposit = '0.00'
            if (this.isOnline && this.user.available_predeposit) {
                availablePredeposit = this.user.available_predeposit
            }
            return availablePredeposit
        },
        getlevelname() {
            let levelname = ''
            if (this.isOnline && this.user.level_name) {
                levelname = this.user.level_name
            }
            return levelname
        }
    },
    methods: {
        ...mapActions({
            fetchConfig: 'fetchConfig',
        }),
        ...mapMutations({
            memberLogout: 'memberLogout',
        }),
        getEmail() {
            this.$router.push({ name: 'MemberContactUs' })
        },
        getIF() {
            this.$router.push({ name: 'MemberInviteFriends' })
        },
        signout() {
            this.$router.push({ name: 'MemberSignOut' })
        },
        logout() {
            logout(this.user.member_name).then(res => {
                this.memberLogout()
                this.$router.push({ name: 'HomeMemberLogin' })
            }).catch(function (error) {
                Toast(error.message)
            })
        },
        showLogin() {
            this.$router.push({ name: 'HomeMemberLogin' })
        },
        goScoreList() {
            if (this.isOnline) {
                this.$router.push({ name: 'MemberPointList', query: { index: 0 } })
            } else {
                this.showLogin()
            }
        },
        goOrder() {
            if (this.isOnline) {
                this.$router.push({
                    name: 'MemberOrderList'
                })
            } else {
                this.showLogin()
            }
        },
        goBox() {
            if (this.isOnline) {
                this.$router.push({
                    name: 'BlindBoxList'
                })
            } else {
                this.showLogin()
            }
        },
        setLang() {
            this.$router.push({ name: 'HomeLang' })
        },
        onRetrieve() {
            // this.$router.push({ name: 'HomeMemberForget' })
            this.$router.push({ name: 'MemberChangePassword' })
        },
        goGiftBoxList() {
            if (this.isOnline) {
                this.$router.push({
                    name: 'GiftBoxList'
                })
            } else {
                this.showLogin()
            }
        },
        goGiftSave() {
            if (this.isOnline) {
                this.$router.push({
                    name: 'GiftSave'
                })
            } else {
                this.showLogin()
            }
        },
        goProfileInfo() {
            if (this.isOnline) {
                this.$router.push({ name: 'MemberProfileSet' })
            } else {
                this.showLogin()
            }
        },
        goSetting() {
            this.$router.push({ name: 'MemberSetting' })
        },
        // 消息通知
        goNews() {
            if (this.isOnline) {
                this.$router.push({ name: 'MemberNoticeList' })
            } else {
                this.showLogin()
            }
        },
        // 我的关注
        goFavourite() {
            if (this.isOnline) {
                this.$router.push({ name: 'MemberFavorite' })
            } else {
                this.showLogin()
            }
        },
        // 我的地址
        goAddress() {
            if (this.isOnline) {
                this.$router.push({ name: 'MemberAddressList' })
            } else {
                this.showLogin()
            }
        },
        // 我的退款
        goReturn() {
            if (this.isOnline) {
                this.$router.push({ name: 'MemberOrderreturn' })
            } else {
                this.showLogin()
            }
        },
        goAccount() {
            if (this.isOnline) {
                this.$router.push({ name: 'MemberAccount' })
            } else {
                this.showLogin()
            }
        },
        goCommission(e) {
            if (this.isOnline) {
                this.$router.push({ name: 'MemberCommission', query: { indexe: e } })
            } else {
                this.showLogin()
            }
        },
        goPredeposit() {
            if (this.isOnline) {
                this.$router.push({ name: 'MemberPredepositList' })
            } else {
                this.showLogin()
            }
        },
        // 我的好友列表
        goFriendList() {
            if (this.isOnline) {
                this.$router.push({ name: 'MemberFriendList' })
            } else {
                this.showLogin()
            }
        },
        // 商家入驻
        goSellerJoinin() {
            if (this.isOnline) {
                this.$router.push({ name: 'SellerJoinin1' })
            } else {
                this.showLogin()
            }
        },
        // 聊天列表
        goMemberChatList() {
            if (this.isOnline) {
                this.$router.push({ name: 'MemberChatList' })
            } else {
                this.showLogin()
            }
        },
        // 我的订单评价
        goEvaluateList() {
            if (this.isOnline) {
                this.$router.push({ name: 'MemberEvaluateList' })
            } else {
                this.showLogin()
            }
        },
        // 发票管理
        goInvoice() {
            if (this.isOnline) {
                this.$router.push({ name: 'MemberInvoiceList' })
            } else {
                this.showLogin()
            }
        },
        // 跳转卖家管理中心
        goSellerInfo() {
            if (this.isOnline) {
                this.$router.push({ name: 'SellerIndex' })
            } else {
                this.showLogin()
            }
        },
        // 分销管理中心
        goMemberInviterManage() {
            if (this.isOnline) {
                checkInviter().then(res => {
                    this.$router.push({ name: 'MemberInviterManage' })
                }).catch(function (error) {
                    Toast(error.message)
                })
            } else {
                this.showLogin()
            }
        },
        goMyCommission() {
            if (this.isOnline) {
                checkInviter().then(res => {
                    this.$router.push({ name: 'MemberCommission' })
                }).catch(function (error) {
                    Toast(error.message)
                })
            } else {
                this.showLogin()
            }
        },
        // 意见反馈
        goMemberFeedback() {
            if (this.isOnline) {
                this.$router.push({ name: 'MemberFeedback' })
            } else {
                this.showLogin()
            }
        },
        // 虚拟订单
        goVrOrder() {
            if (this.isOnline) {
                this.$router.push({ name: 'MemberVrOrderList' })
            } else {
                this.showLogin()
            }
        },
        // 活动记录
        goMarketmanagelog() {
            if (this.isOnline) {
                this.$router.push({ name: 'MemberMarketmanagelog' })
            } else {
                this.showLogin()
            }
        },
        // 砍价活动
        gBargain() {
            if (this.isOnline) {
                this.$router.push({ name: 'MemberBargainlist' })
            } else {
                this.showLogin()
            }
        },
        // 到货通知
        goArrivalnotice() {
            if (this.isOnline) {
                this.$router.push({ name: 'MemberArrivalnotice' })
            } else {
                this.showLogin()
            }
        },
        // 浏览历史
        goBrowse() {
            if (this.isOnline) {
                this.$router.push({ name: 'MemberBrowseList' })
            } else {
                this.showLogin()
            }
        },
        gotobuy() {
            this.$router.push({ name: 'HomeGoBuy' })
        },
    }
}
</script>
  
<style scoped lang="scss">
.container {
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: stretch;
    background-color: #F9F9F9;
    text-align: center;
    padding: 0 250px;
    height: 100%;

    .top-wrapper {
        position: relative;
        height: 11rem;
        background-image: url("../../../assets/image/member/bg_wode_com.png");
        background-repeat: no-repeat;
        background-size: 100%;
        background-position: 100% -60%;

        .top-info-wrapper {
            flex: 1;
            width: 100%;
            text-align: center;
            margin-top: 2rem;
        }
    }

    .nav-item {
        position: absolute;
        display: flex;
        justify-content: center;
        align-items: center;
        top: 1.2rem;

        span {
            width: 0.4rem;
            height: 0.4rem;
            background-color: #f0f2f5;
            border-radius: 50%;
            position: absolute;
            top: 0.5rem;
            right: 0.5rem;
        }
    }

    #left-nav-item {
        left: 0.7rem;
    }

    #right-nav-item {
        right: 0.7rem;
    }

    .nav-icon {
        width: 1rem;
        height: 1rem;
        text-align: center;
        color: #fff;
    }

    .avatar-wrapper {
        position: relative;
        width: 6rem;
        height: 6rem;
        border-radius: 50%;
        background-color: #fff;
        margin: 0 auto;
        margin-top: 1rem;

        .avatar {
            width: 5rem;
            height: 5rem;
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
        }
    }

    .nickname {
        width: 100%;
        margin-top: 0.75rem;
        font-size: 24px;
        font-weight: 600;
        color: rgb(0, 0, 0);
        text-align: center;
        margin-left: 0;
        margin-right: 0;
    }

    .uid {
        margin-top: 0.15rem;
        font-size: 15px;
        color: #7C7C7C;
    }

    .level_name_wrapper {
        font-size: .6rem;
        color: rgba(255, 255, 255, 1);
        text-align: center;
        margin-left: 0;
        margin-right: 0;
        border-radius: .2rem;
        border: 1px solid #fff;
        display: inline-block;
        padding: 0.1rem .2rem;
    }

    .level_name {
        display: flex;
        align-items: center;
    }

    .levelname-icon {
        width: 1rem;
        height: .6rem;
        padding-right: .2rem;
    }

    .info-wrapper {
        position: absolute;
        bottom: -5.5rem;
        left: 1.5rem;
        right: 1.5rem;
        padding: 10px;
        display: inline-flex;
        flex-direction: row;
        justify-content: flex-start;
        align-content: stretch;
        background-color: #fff;
        border-radius: .4rem;
        box-shadow: 0px 4px 4px #f7f7f7;
        z-index: 2;
    }

    .info-item {
        flex: 1;
        text-align: center;
        font-size: $h2;
        color: #7F7F7F;
        position: relative;

        &:first-child::after {
            // content: '';
            position: absolute;
            top: .5rem;
            bottom: .5rem;
            right: 0;
            border-right: 1px dashed #eee;
        }

        .item {
            padding-top: .5rem;
        }

        .price {
            color: #FB2933;
            padding-bottom: .5rem;
            font-weight: 600;
        }
    }

    .order-header {
        background-color: #fff;
        padding: 0 $pageSpace;
        margin-top: $modelSpace;
    }

    .item-title {
        font-size: $subFontSize;
        color: $formInputColor;
        font-weight: 700;
    }

    .order-subtitle {
        font-size: $fontSize;
        color: $descTextColor;
    }

    .order {
        margin: 12px 25px;
        padding: 8px 12px;
        background: #fff;
        border-radius: 10px;

        .order-header {
            margin: 0 0 1rem 0;
            padding: 0;
            min-height: auto;
        }
    }

    .order-wrapper {
        padding: 10px 0;
        // height: 4rem;
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: stretch;
        background-color: #fff;
    }

    .order-item {
        flex: 1;
    }

    .bottom-wrapper {
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
        align-items: stretch;
        margin-top: $modelSpace;
        margin-bottom: $modelSpace;
        background: #fff;
        padding: 0 $pageSpace;

        .item-icon {
            width: 1.2rem;
            height: 1.2rem;
            margin-right: .4rem;
        }
    }

    .manage-wrapper {
        background: #fff;
    }
}

.banner {
    margin: 6rem 25px 10px;

    img {
        width: 100%;
        height: 100%;
    }
}
</style>
  